import { Locale } from '@frontend/common';
import { useLocale } from '@frontend/lang';
import { useListRepository } from '@frontend/repository';
import { useEffect } from 'react';
import { Location, NavigateFunction, useLocation, useNavigate } from 'react-router-dom';

import { CardListProps } from './card-list.component';

interface ViewProps<T extends object> extends ReturnType<typeof useListRepository<T>> {
    data: T[] | null;
    location: Location;
    navigate: NavigateFunction;
    locale?: Locale;
}

const useCardList = <T extends { id: string; name: string }>(props: CardListProps<T>): ViewProps<T> => {
    const location = useLocation();
    const navigate = useNavigate();
    const { locale } = useLocale();
    const repository = useListRepository<T>({
        fetch: (arg) => props.fetch(arg),
        dispatch: props.dispatch,
        eventListener: props.eventListener,
        listId: props.useStaticListId === true ? props.id : undefined
    });

    useEffect(() => {
        props.listStoreIdCallback && props.listStoreIdCallback(repository.listId);
    }, [repository.listId, props.listStoreIdCallback]);

    return {
        ...repository,
        data: repository.data,
        location,
        navigate,
        locale
    };
};

export default useCardList;
